<template>
  <a
    :href="url"
    target="_blank"
    rel="noopener noreferrer"
    class="block rounded-lg overflow-hidden bg-black/30 border border-white/5 hover:border-white/15 transition-colors max-w-sm"
  >
    <img
      v-if="preview.imageUrl"
      :src="preview.imageUrl"
      :alt="preview.title || url"
      class="w-full max-h-48 object-cover"
      loading="lazy"
      @error="onImgError"
    />
    <div class="p-2.5">
      <p v-if="preview.siteName" class="text-[9px] text-text-dim uppercase tracking-widest mb-0.5 truncate">
        {{ preview.siteName }}
      </p>
      <p v-if="preview.title" class="text-xs font-semibold text-white truncate">
        {{ preview.title }}
      </p>
      <p v-if="preview.description" class="text-[11px] text-text-muted line-clamp-2 mt-1">
        {{ preview.description }}
      </p>
      <p v-if="!preview.title && !preview.description" class="text-[11px] text-text-muted truncate">
        {{ url }}
      </p>
    </div>
  </a>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  url: { type: String, required: true },
  preview: { type: Object, required: true }
})

// If the preview image 404s, hide it so the card still looks clean
function onImgError(e) {
  e.target.style.display = 'none'
}
</script>

<style scoped>
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
